import createPersistedState from 'vuex-persistedstate'

import Vue from 'vue'
import Vuex from 'vuex'
import { loadStoreModules } from './loadStoreFromFeatures'

Vue.use(Vuex)

const modules = loadStoreModules()

export default new Vuex.Store({
  strict: true,
  state: {
    baseAPI: process.env.VUE_APP_API_URL || 'http://localhost:8003/api'
  },
  modules,
  mutations: {},
  actions: {},
  getters: {},
  plugins: [
    createPersistedState({
      paths: ['authentication', 'persistentValues']
    })
  ]
})
